import React, { Fragment, ReactElement } from "react";

import { useIsClientSide } from "@utils/hooks/isClient.hook";

interface ClientOnlyComponentProps {
    loadingComponent?: ReactElement;
    isLoading?: boolean;
    children?: React.ReactNode;
}

const ClientOnlyComponent = ({
    isLoading = false,
    children,
    loadingComponent,
}: ClientOnlyComponentProps) => {
    const isClient = useIsClientSide();

    const clientSide = <Fragment>{children}</Fragment>;
    const serverSide = (
        <Fragment>{loadingComponent ? loadingComponent : null}</Fragment>
    );
    return isClient && !isLoading ? clientSide : serverSide;
};

export { ClientOnlyComponent };
